import React from 'react';
import PropTypes from 'prop-types';
import { strings } from './../../localization';

export default class SelectDropDown extends React.PureComponent {

    static propTypes = {
        enableFilter: PropTypes.bool,
        enableSearch: PropTypes.bool,
        enableSimplifiedClear: PropTypes.bool,
        options: PropTypes.array.isRequired,
        onChange: PropTypes.func.isRequired,
        onSetAll: PropTypes.func,
        singleOnlySelection: PropTypes.bool,
        requiredSelection: PropTypes.bool,
        searchCheckboxFilter: PropTypes.bool,
        isDefaultOptional: PropTypes.bool,
        isDefaultSelectAll: PropTypes.bool,
        nameEmbeddedSelectBox: PropTypes.string
    }

    constructor(props) {

        super(props);

        this.state = {
            filterString: "",
            expanded: false
        }

        this.mouseLeaveTimeout = undefined;
        this.containerElemnent = React.createRef();
    }

    componentDidMount() {
        // document.addEventListener("mouseup", this.onClickOutsideContainer);
        document.addEventListener("mousedown", this.onClickOutsideContainer);

        //auto-click filters by default
        if (this.buttonRef && !this.props.isDefaultOptional) {
            setTimeout(() => {
                this.buttonRef.click();
            }
                , 0);
        }
    }

    componentDidUpdate(prevProps) {
        if (this.props.singleOnlySelection && prevProps.options !== this.props.options) {
            this.setState({ expanded: false });
        }
    }

    componentWillUnmount() {
        // document.removeEventListener("mouseup", this.onClickOutsideContainer);
        document.removeEventListener("mousedown", this.onClickOutsideContainer);
    }

    onClickOutsideContainer = (event) => {
        if (this.containerElemnent && !this.containerElemnent.current.contains(event.target)) {
            clearTimeout(this.mouseLeaveTimeout);
            this.setState({ expanded: false });
        }
    }

    onFilterStringInput = (event) => {

        this.setState({
            filterString: event.target.value// async setState
        });

        const lowercasedFilterString = event.target.value.toLocaleLowerCase(); // avoid async issues by using the event.target.value directly
        if (lowercasedFilterString) {
            this.props.options.forEach((option, index) => {
                const lowercasedOptionLabel = option.label.toLowerCase();
                if (lowercasedOptionLabel.indexOf(lowercasedFilterString) === -1) {
                    if (option.checked) {
                        this.props.onChange(index, false);
                    }
                    return null;
                }
            });
        }

    }

    render() {

        let totalSelected = 0;
        let singleOnlySelectionSelectedItemLabel;

        let optionsElements = this.props.options.map((option, index) => {
            if (option.checked) {
                totalSelected += 1;
                singleOnlySelectionSelectedItemLabel = option.label;
            }
            const lowercasedFilterString = this.state.filterString.toLocaleLowerCase();
            const lowercasedOptionLabel = option.label.toLowerCase();
            if (lowercasedFilterString) {
                if (lowercasedOptionLabel.indexOf(lowercasedFilterString) === -1) {
                    return null;
                }
            }
            return (
                <label htmlFor={option.value} key={index} title={option.label}>
                    <input type={this.props.singleOnlySelection ? "radio" : "checkbox"} id={option.value} checked={option.checked} onChange={() => {
                        this.props.onChange(index);
                    }} />
                    {option.label}
                </label>
            )
        });
        
        const showError = (this.props.forceSelection ?? true); // If props.forceSelection is not defined, it is considered as true
        const placeholder = this.props.placeholder ?? "";
        const embeddedName = this.props.nameEmbeddedSelectBox ? this.props.nameEmbeddedSelectBox + ": " : "";
        return (
            <form className="form-common"
                id={`review-multiselect-form-for-${this.props.for}`}
                ref={this.containerElemnent}
                onMouseLeave={() => {
                    this.mouseLeaveTimeout = setTimeout(() => {
                        this.setState({ expanded: false })
                    }, 900);
                }}
                onMouseEnter={() => { clearTimeout(this.mouseLeaveTimeout) }}
            >
                <div className={`review-multiselect ${this.state.expanded ? "expanded" : ""}`}>
                    <div className="select-box">
                        <div className={`select-header ${(totalSelected ? "" : (this.props.requiredSelection ? "error" : "optional"))}`}>
                            {this.props.singleOnlySelection ?
                                <div className='option'>{embeddedName + singleOnlySelectionSelectedItemLabel}</div>
                                :
                                (embeddedName !== "" ?
                                    (this.props.requiredSelection ?
                                        <div className='option'>{totalSelected ? embeddedName + strings.formatString(strings.reports_filter_x_selected, totalSelected) : embeddedName + strings.reports_filter_select_at_least_one}</div>
                                        :
                                        <div className='option'>{totalSelected ? embeddedName + strings.formatString(strings.reports_filter_x_selected, totalSelected) : embeddedName + strings.reports_filter_select}</div>
                                    )
                                    :
                                    (this.props.requiredSelection ?
                                        <div className='option'>{totalSelected ? strings.formatString(strings.reports_filter_x_selected, totalSelected) : strings.reports_filter_select_at_least_one}</div>
                                        :
                                        <div className='option'>{totalSelected ? strings.formatString(strings.reports_filter_x_selected, totalSelected) : strings.reports_filter_select}</div>
                                    )
                                )
                            }
                            <i className="material-icons">keyboard_arrow_down</i>
                        </div>
                        <div className="select-input-overlay" onClick={() => { this.setState({ expanded: !this.state.expanded }) }}>
                            {this.props.enableSimplifiedClear && totalSelected > 0 ?
                                <div className="expander-clear-button" onClick={(event) => {
                                    event.preventDefault();
                                    this.props.onSetAll(false, this.state.filterString);
                                }}>
                                    <i className="material-icons">clear</i>
                                </div>
                                :
                                null
                            }
                        </div>
                    </div>
                    <div className="checkboxes" style={{ display: this.state.expanded ? "block" : "none" }} >
                        {this.props.enableFilter ?
                            <div className="checkbox-filters">
                                <div>
                                    <input type="text" placeholder={strings.action_search} value={this.state.filterString} onChange={this.onFilterStringInput} />
                                </div>
                                <div>
                                    {this.props.children}
                                </div>
                                <div className="actions">
                                    <button ref={(button) => { this.buttonRef = button; }} onClick={(event) => {
                                        event.preventDefault();
                                        this.props.onSetAll(true, this.state.filterString);
                                        this.setState({ expanded: false });
                                    }} >
                                        {strings.faces_select_all}
                                    </button>
                                    <button onClick={(event) => {
                                        event.preventDefault();
                                        this.props.onSetAll(false, this.state.filterString);
                                        this.setState({ expanded: false });
                                    }} >
                                        {strings.action_select_none}
                                    </button>
                                </div>
                            </div>
                            :
                            null
                        }
                        {this.props.enableSearch ?
                            <div className="checkbox-filters">
                                <div>
                                    <input type="text" placeholder={strings.action_search} value={this.state.filterString} onChange={this.onFilterStringInput} />
                                </div>
                                <div>
                                    {this.props.children}
                                </div>
                            </div>
                            :
                            null
                        }
                        <div className="options-scroll-wrapper">
                            {optionsElements}
                        </div>
                    </div>
                </div>
            </form>
        )
    }
}